module.exports = __webpack_public_path__ + "static/media/discover_getshift.e468cf0a.webp";